import { Component } from '@angular/core';

@Component({
    selector: 'inka-mascot-sad',
    templateUrl: './mascot-sad.component.html',
    styleUrls: ['./mascot-sad.component.scss'],
    standalone: false
})
export class MascotSadComponent {

}
